import React from 'react'
import { PaginationInfo } from './PaginationInfo'
import { PaginationPageSizeSelect } from './PaginationPageSizeSelect'
import { PaginationControls } from './PaginationControls'
import { getPageNumbers, getPaginationRange, getTotalPages } from './pagination.utils'
import type { PaginationProps } from './pagination.types'
import { defaultTranslate } from './pagination.default'

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalRecords,
  pageSize,
  onPageChange,
  onPageSizeChange,
  disabled = false,
  pageSizeOptions = [10, 20, 50, 100],
  t = defaultTranslate,
}) => {
  const totalPages = getTotalPages(totalRecords, pageSize)
  const { startItem, endItem } = getPaginationRange(currentPage, pageSize, totalRecords)
  const pages = getPageNumbers(currentPage, totalPages)

  if (totalPages === 0) {
    return null
  }

  const handlePrevious = () => {
    if (currentPage > 1 && !disabled) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages && !disabled) {
      onPageChange(currentPage + 1)
    }
  }

  const handlePageClick = (page: number) => {
    if (page !== currentPage && !disabled) {
      onPageChange(page)
    }
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-border-t tw-border-content-base tw-border-opacity-10 tw-bg-white tw-px-6 tw-py-4 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between">
      <div className="tw-flex tw-flex-col tw-gap-3 tw-text-sm sm:tw-flex-row sm:tw-items-center sm:tw-gap-6">
        <PaginationInfo
          startItem={startItem}
          endItem={endItem}
          totalRecords={totalRecords}
          t={t}
        />

        <PaginationPageSizeSelect
          value={pageSize}
          options={pageSizeOptions}
          disabled={disabled}
          onChange={onPageSizeChange}
          t={t}
        />
      </div>

      <PaginationControls
        currentPage={currentPage}
        totalPages={totalPages}
        disabled={disabled}
        pages={pages}
        onPrevious={handlePrevious}
        onNext={handleNext}
        onPageClick={handlePageClick}
        t={t}
      />
    </div>
  )
}
